import { Navigate, generatePath } from 'react-router-dom';

import { NBA_SCOUTING_CENTER_STATS } from '@sorare/core/src/constants/__generated__/routes';

const ScoutingCenterPage = () => {
  return <Navigate to={generatePath(NBA_SCOUTING_CENTER_STATS)} />;
};

export default ScoutingCenterPage;
